import React, { memo } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { sanitizeDiscard } from '@Services/HtmlSanitizeService';
import InnerHTML from '@Components/InnerHTML';
import StructureImage from '@Pages/Heatmap/components/StructureImage';

import './TooltipContentStructure.scss';

function TooltipContentStructure({ path, label, id, casNumbers, formula, weight }) {
  const title = sanitizeDiscard(label, { allowedTags: [] });

  return (
    <div className="heatmap-tooltip-content-structure">
      <div className="heatmap-tooltip-content-structure__image-container">
        {path ? <StructureImage path={path} title={title} /> : <InnerHTML tag="div" className="noimg-label" html={label} />}
      </div>
      <div className="heatmap-tooltip-content-structure__details-row">
        <div className="heatmap-tooltip-content-structure__details-name">Reaxys ID:</div>
        <div className="heatmap-tooltip-content-structure__details-value">{id}</div>
      </div>
      {!isEmpty(casNumbers) && (
        <div className="heatmap-tooltip-content-structure__details-row">
          <div className="heatmap-tooltip-content-structure__details-name">CAS Registry Number:</div>
          <div className="heatmap-tooltip-content-structure__details-value">{casNumbers[0]}</div>
        </div>
      )}
      <div className="heatmap-tooltip-content-structure__details-row">
        <div className="heatmap-tooltip-content-structure__details-name">Molecular Formula:</div>
        <InnerHTML tag="div" className="heatmap-tooltip-content-structure__details-value" title={formula} html={formula} />
      </div>
      <div className="heatmap-tooltip-content-structure__details-row">
        <div className="heatmap-tooltip-content-structure__details-name">Molecular Weight:</div>
        <div className="heatmap-tooltip-content-structure__details-value">{weight}</div>
      </div>
    </div>
  );
}

TooltipContentStructure.propTypes = {
  label: PropTypes.string,
  formula: PropTypes.string,
  casNumbers: PropTypes.array,
  weight: PropTypes.string,
  id: PropTypes.string,
  path: PropTypes.string,
};

export default memo(TooltipContentStructure);
